/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserPagination } from 'model/user';
import { Action } from 'redux';

export const USER_ERROR = 'user/error';
interface UserErrorAction extends Action<typeof USER_ERROR> {
    payload: {
        error: string;
    };
}

export const USER_CLEAR_ERROR = 'user/clear_error';
type UserClearErrorAction = Action<typeof USER_CLEAR_ERROR>;

export const USER_CLEAR_SUCCESS = 'user/clear_success';
type UserClearSuccessAction = Action<typeof USER_CLEAR_SUCCESS>;

export const USER_RESET = 'user/reset';
type UserResetAction = Action<typeof USER_RESET>;

export const USER_FETCH_START = 'user/fetch_start';
type UserFetchStartAction = Action<typeof USER_FETCH_START>;

export const USER_FETCH_SUCCESS = 'user/fetch_success';
interface UserFetchSuccessAction extends Action<typeof USER_FETCH_SUCCESS> {
    payload: {
        users: Array<any>;
        pagination?: UserPagination;
    };
}

export const USER_SAVE_START = 'user/save_start';
type UserSaveStartAction = Action<typeof USER_SAVE_START>;

export const USER_SAVE_SUCCESS = 'user/save_success';
interface UserSaveSuccessAction extends Action<typeof USER_SAVE_SUCCESS> {
    payload: {
        user: any;
    };
}

export const USER_DELETE_START = 'user/delete_start';
type UserDeleteStartAction = Action<typeof USER_DELETE_START>;

export const USER_DELETE_SUCCESS = 'user/delete_success';
interface UserDeleteSuccessAction extends Action<typeof USER_DELETE_SUCCESS> {
    payload: {
        userId: number;
    };
}

export type UserAction =
    | UserErrorAction
    | UserClearErrorAction
    | UserClearSuccessAction
    | UserResetAction
    | UserFetchStartAction
    | UserFetchSuccessAction
    | UserSaveStartAction
    | UserSaveSuccessAction
    | UserDeleteStartAction
    | UserDeleteSuccessAction;
